<script lang="ts">
  import type { CostCalculation } from "../../helpers/types";
  import { roundOf } from "../../helpers/priceCalculator";

  interface Props {
    costs: CostCalculation;
    position?: "right" | "left";
    previousMonth?: string;
    productType: "fixed" | "variable" | "hourly";
    class?: string;
    hasFetchedAutomatic?: boolean;
    zipcode?: string;
  }

  let {
    costs,
    position = "right",
    previousMonth = undefined,
    productType,
    class: className,
    hasFetchedAutomatic = false,
    zipcode,
  }: Props = $props();

  const formatMonth = (month: string): string => (month.endsWith("s") ? month : month + "s");
</script>

<section
  class="{className} text-L py-2 sm:p-0 {position == 'right'
    ? 'md:text-right'
    : ''} select-none flex-shrink-0"
>
  {#if costs.discount}
    <div>
      <div class="text-Neutral900 text-sm">
        <span class="font-normal">Elpris:</span>
        <span class="font-bold">
          {roundOf((costs.discount.kwhCost + costs.discount.kwhVat) * 100)} öre/kwh
        </span>
      </div>
      <div class="-mt-1">
        <span class="text-Neutral700 text-xs">
          <s>{roundOf((costs.kwhCost + costs.kwhVat) * 100)} öre/kwh</s>
        </span>
      </div>
      {#if productType !== "hourly"}
        <span class="text-sm mt-2">
          Ca <span class="text-Green700 font-bold">{costs.discount.estimationCost} kr/månad</span>
        </span>
        <span class="text-Neutral700 text-xs block"><s>{costs.estimationCost} kr/månad</s></span>
      {/if}
      {#if previousMonth && (productType === "variable" || productType === "hourly")}
        <span class="text-Neutral700 text-H6 mb-2">
          *Uppskattad kostnad baserad på {formatMonth(previousMonth)} elpris {hasFetchedAutomatic
            ? `för postnummer ${zipcode}`
            : ""}
        </span>
      {/if}
    </div>
  {:else}
    <div class="text-Neutral900 text-sm">
      <span class="font-normal">Elpris:</span>
      <span class="font-bold">
        {roundOf((costs.kwhCost + costs.kwhVat) * 100)} öre/kwh
      </span>
    </div>
    {#if productType !== "hourly"}
      <span class="text-sm mt-2">
        Ca <span class="text-Green700 font-bold">{costs.estimationCost} kr/månad</span>
      </span>
    {/if}
    {#if previousMonth && (productType === "variable" || productType === "hourly")}
      <span class="text-Neutral700 text-H6 mb-2">
        *Uppskattad kostnad baserad på {formatMonth(previousMonth)} elpris {hasFetchedAutomatic
          ? `för postnummer ${zipcode}`
          : ""}
      </span>
    {/if}
  {/if}
</section>
